import React, { useEffect, useState } from 'react';
import request from '../../../services/Request';
import LoadingIcon from '../../items/buttons/LoadingIcon';
import BackButton from '../../items/buttons/BackButton';
import ModernTable, { ModernPageContainer, ModernPageHeader } from '../components/ModernTable';
import {
  Grid,
  Container,
  Autocomplete,
  TextField,
  Button,
  FormControlLabel,
  RadioGroup,
  Radio,
  Box,
  Typography,
  Chip,
  alpha,
  Paper,
} from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import moment from 'moment';
import { CloudDownload } from '@mui/icons-material';
import { localDateRange } from '../../../services/method/methods';
import { userLimits } from '../uitls/userLimits';
import { ExportToCsv } from 'export-to-csv';
import InventoryIcon from '@mui/icons-material/Inventory';
import PersonIcon from '@mui/icons-material/Person';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import TrendingDownIcon from '@mui/icons-material/TrendingDown';

const getMachinesURL = '/machines/getMyMachines/';
const getGroupsURL = `/groupsAndMachinesForReport/`;
const getLogsURL = '/stockLog/';

export default function StockLog(props) {
  const theme = useTheme();
  var date = new Date();
  const [loading, setLoading] = useState(false);
  const [startDate, setStartDate] = useState(new Date(date.getFullYear(), date.getMonth(), 1));
  const [endDate, setEndDate] = useState(new Date());
  // const [startDateString, setStartDateString] = useState(
  //   new Date(date.getFullYear(), date.getMonth(), 1).toISOString()
  // );
  // const [endDateString, setEndDateString] = useState(new Date().toISOString());

  const [selectP, setSelectP] = useState({ name: '' });
  const [machines, setMachines] = useState([]);
  const [stockLog, setstockLog] = useState([]);
  const [planoLog, setPlanoLog] = useState([]);
  const [radio, setRadio] = useState('s');
  const [pagination, setPagination] = useState(
    localStorage.getItem('table_view_stocking') ? localStorage.getItem('table_view_stocking') : 10
  );

  useEffect(() => {
    localStorage.setItem('table_view_stocking', pagination);
  }, [pagination]);
  const user = JSON.parse(localStorage.getItem('user'));

  const { _id, id, tableTitle, superAdmin } = userLimits(
    props.match.params.id,
    props.match.params.group,
    'Stock Logs',
    'view_report'
  );

  useEffect(() => {
    async function getMachine() {
      await request({
        method: 'get',
        url:
          props.match.params.group && superAdmin
            ? getGroupsURL + props.match.params.id
            : getGroupsURL + user?.email,
      }).then((res) => {
        console.log('res.data', res.data);
        setMachines(res.data.machines);
        setLoading(true);
      });
    }
    getMachine();
    return () => {
      setMachines([]);
      setLoading(true);
    };
  }, []);

  const handleStartDate = (e) => {
    setStartDate(e);
    // setStartDateString(e.toISOString());
  };

  const handleEndDate = (e) => {
    setEndDate(e);
    // setEndDateString(e.toISOString());
  };

  const handleChange = async () => {
    const { startDateString, endDateString } = localDateRange(startDate, endDate);

    await request({
      method: 'get',
      url: getLogsURL + selectP._id + '/' + startDateString + '/' + endDateString,
    }).then((res) => {
      console.log(res.data);
      const newArray = [];
      const newPlano = [];
      // console.log('log', res.data);
      res.data.forEach((e) => {
        if (e.plano) {
          newPlano.push({
            date: e.localDate,
            user: e.user ? e.user?.firstname + ' ' + e.user?.lastname : '',
            isOld: e.isOld,
          });
        } else {
          e.prods.forEach((pd) => {
            const modify = pd.current_stock - pd.pre_stock;
            newArray.push({
              date: e.localDate,
              user: e.user ? e.user?.firstname + ' ' + e.user?.lastname : '',
              upc: pd.upc,
              name: pd.id?.name?.en,
              modify: modify,
              pos: pd.idx
                ? pd.row + 'F ' + pd.lane + 'L ' + pd.idx + 'S'
                : pd.row + 'F ' + pd.lane + 'L',
              post_stock: pd.current_stock,
              pre_stock: pd.pre_stock,
              isOld: e.isOld,
            });
          });
        }
      });
      // console.log('newArray', newArray);
      setstockLog(newArray);
      setPlanoLog(newPlano);
      console.log('newPlano', newPlano);
    });
  };

  const columns =
    radio === 's'
      ? [
          {
            title: 'Date',
            render: (rowData) => {
              let date = new Date(rowData.date);
              if (rowData.isOld === 'true') {
                date = moment(date).format('lll');
              } else {
                date = moment.utc(date).format('lll');
              }
              return (
                <Typography variant="body2" sx={{ fontFamily: 'monospace', fontSize: '0.875rem' }}>
                  {date}
                </Typography>
              );
            },
          },
          {
            title: 'User',
            field: 'user',
            render: (rowData) => (
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <PersonIcon sx={{ fontSize: 16, color: theme.palette.text.secondary }} />
                <Typography variant="body2" sx={{ fontWeight: 500 }}>
                  {rowData.user || '-'}
                </Typography>
              </Box>
            ),
          },
          {
            title: 'UPC/SKU',
            field: 'upc',
            render: (rowData) => (
              <Typography variant="body2" sx={{ fontFamily: 'monospace', fontWeight: 600 }}>
                {rowData.upc}
              </Typography>
            ),
          },
          {
            title: 'Name',
            field: 'name',
            render: (rowData) => (
              <Typography variant="body2" sx={{ fontWeight: 600, color: theme.palette.primary.main }}>
                {rowData.name}
              </Typography>
            ),
          },
          {
            title: 'Pre Stock',
            field: 'pre_stock',
            render: (rowData) => (
              <Chip
                label={rowData.pre_stock}
                size="small"
                sx={{
                  fontWeight: 600,
                  backgroundColor: alpha(theme.palette.grey[500], 0.12),
                  color: theme.palette.text.secondary,
                  border: `1.5px solid ${alpha(theme.palette.grey[500], 0.3)}`,
                }}
              />
            ),
          },
          {
            title: 'Post Stock',
            field: 'post_stock',
            render: (rowData) => (
              <Chip
                label={rowData.post_stock}
                size="small"
                sx={{
                  fontWeight: 600,
                  backgroundColor: alpha(theme.palette.info.main, 0.12),
                  color: theme.palette.info.dark,
                  border: `1.5px solid ${alpha(theme.palette.info.main, 0.3)}`,
                }}
              />
            ),
          },
          {
            title: 'Added/Removed',
            field: 'modify',
            render: (rowData) => {
              const isPositive = rowData.modify > 0;
              return (
                <Chip
                  icon={
                    isPositive ? (
                      <TrendingUpIcon sx={{ fontSize: 16 }} />
                    ) : (
                      <TrendingDownIcon sx={{ fontSize: 16 }} />
                    )
                  }
                  label={rowData.modify}
                  size="small"
                  sx={{
                    fontWeight: 600,
                    backgroundColor: isPositive
                      ? alpha(theme.palette.success.main, 0.12)
                      : alpha(theme.palette.error.main, 0.12),
                    color: isPositive ? theme.palette.success.dark : theme.palette.error.dark,
                    border: `1.5px solid ${
                      isPositive
                        ? alpha(theme.palette.success.main, 0.3)
                        : alpha(theme.palette.error.main, 0.3)
                    }`,
                    '& .MuiChip-icon': {
                      color: isPositive ? theme.palette.success.dark : theme.palette.error.dark,
                    },
                  }}
                />
              );
            },
          },
          {
            title: 'Position',
            field: 'pos',
            render: (rowData) => (
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <LocationOnIcon sx={{ fontSize: 16, color: theme.palette.text.secondary }} />
                <Typography variant="body2" sx={{ fontFamily: 'monospace' }}>
                  {rowData.pos}
                </Typography>
              </Box>
            ),
          },
          {
            title: '',
            field: '',
            render: () => null,
          },
        ]
      : [
          {
            title: 'Date',
            render: (rowData) => {
              let date = new Date(rowData.date);
              if (rowData.isOld === 'true') {
                date = moment(date).format('lll');
              } else {
                date = moment.utc(date).format('lll');
              }
              return (
                <Typography variant="body2" sx={{ fontFamily: 'monospace', fontSize: '0.875rem' }}>
                  {date}
                </Typography>
              );
            },
          },
          {
            title: 'User',
            field: 'user',
            render: (rowData) => (
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <PersonIcon sx={{ fontSize: 16, color: theme.palette.text.secondary }} />
                <Typography variant="body2" sx={{ fontWeight: 500 }}>
                  {rowData.user || '-'}
                </Typography>
              </Box>
            ),
          },
          {
            title: '',
            field: '',
            render: () => null,
          },
        ];
  return (
    <ModernPageContainer>
      {!loading && <LoadingIcon />}

      <ModernPageHeader
        title={tableTitle || 'Stock Logs'}
        subtitle="Track inventory stocking and planogram changes"
        icon={InventoryIcon}
      />

      <Paper
        sx={{
          p: 3,
          mt: 3,
          borderRadius: 3,
          backgroundColor: theme.palette.background.paper,
          border: `1px solid ${theme.palette.divider}`,
        }}
      >
        <Grid container spacing={3}>
          <Grid container item xs={12} alignItems="center" justifyContent="center">
            <Grid xs={3} item container justifyContent="flex-start">
              <LocalizationProvider dateAdapter={AdapterDateFns}>
                <DatePicker
                  value={startDate}
                  onChange={(e) => handleStartDate(e)}
                  label="Select start date"
                  format="MM/dd/yyyy"
                  slotProps={{
                    textField: {
                      margin: 'normal',
                      id: 'date-picker-start',
                      sx: { mr: 1 },
                    },
                  }}
                />
                <DatePicker
                  value={endDate}
                  onChange={(e) => handleEndDate(e)}
                  label="Select end date"
                  format="MM/dd/yyyy"
                  slotProps={{
                    textField: {
                      margin: 'normal',
                      id: 'date-picker-end',
                    },
                  }}
                />
              </LocalizationProvider>
            </Grid>
            <Grid xs={2}>
              <RadioGroup
                name="bg_radio"
                sx={{ height: '100%' }}
                onChange={(e) => {
                  setRadio(e.target.value);
                }}
              >
                <FormControlLabel
                  sx={{ m: 0 }}
                  value="s"
                  control={<Radio />}
                  label="Stocking"
                  checked={radio === 's'}
                />
                <FormControlLabel
                  sx={{ m: 0 }}
                  value="p"
                  control={<Radio />}
                  label="Planogram"
                  checked={radio === 'p'}
                />
              </RadioGroup>
            </Grid>
            <Grid item xs={4} sx={{ ml: 2 }}>
              <Autocomplete
                value={selectP}
                fullWidth
                id="addToMachine"
                options={machines}
                onChange={(event, value) => {
                  setSelectP(value);
                }}
                getOptionLabel={(option) =>
                  option.description ? `${option.name}(${option.description})` : option.name
                }
                renderInput={(params) => (
                  <TextField {...params} label="Select a Machine" variant="outlined" />
                )}
              />
            </Grid>
            <Grid item xs={1} sx={{ ml: 2 }}>
              <Button
                sx={{ height: '40px' }}
                disabled={!selectP?.name}
                onClick={() => {
                  handleChange();
                }}
                variant="contained"
                color="primary"
              >
                Submit
              </Button>
            </Grid>
          </Grid>
        </Grid>
      </Paper>

      <Box sx={{ mt: 3 }}>
        <ModernTable
          onRowsPerPageChange={setPagination}
          columns={columns}
          data={radio === 's' ? stockLog : planoLog}
          options={{
            actionsColumnIndex: -1,
            pageSize: parseInt(pagination),
            pageSizeOptions: [10, 20, 50, 100, 200],
          }}
          actions={[
            {
              tooltip: 'Download csv',
              isFreeAction: true,
              icon: CloudDownload,
              onClick: (evt, data) => {
                let outPutArray = [];
                if (radio === 's') {
                  outPutArray = stockLog?.map((e) => {
                    return {
                      Date: moment.utc(e.date).format('YYYY-MM-DD HH:mm:ss a'),
                      User: e.user,
                      UPC: e.upc,
                      Name: e.name,
                      Position: e.idx ? e.row + 'F ' + e.lane + 'L ' + e.idx + 'S' : e.pos,
                      Post_Stock: e.post_stock,
                      Pre_Stock: e.pre_stock,
                      'Added/Removed': e.modify,
                    };
                  });
                } else {
                  outPutArray = planoLog?.map((e) => {
                    return {
                      Date: moment.utc(e.date).format('YYYY-MM-DD HH:mm:ss a'),
                      User: e.user,
                    };
                  });
                }

                const options = {
                  fieldSeparator: ',',
                  quoteStrings: '"',
                  decimalSeparator: '.',
                  useTextFile: false,
                  filename: 'Inventory_report',
                  useKeysAsHeaders: true,
                };

                const csvExporter = new ExportToCsv(options);
                csvExporter.generateCsv(outPutArray);

                // if (outPutArray.length > 0) {
                //   let csv = 'data:text/csv;charset=utf-8,';
                //   let header = Object.keys(outPutArray[0]).join(',');

                //   let values = outPutArray.map((o) => Object.values(o).join(',')).join('\n');
                //   //extra for non sold

                //   csv += header + '\n' + values;

                //   var encodedUri = encodeURI(csv);
                //   var link = document.createElement('a');
                //   link.setAttribute('href', encodedUri);
                //   link.setAttribute('download', 'Inventory_report.csv');
                //   document.body.appendChild(link); // Required for FF

                //   link.click();
                // }
              },
            },
          ]}
        />
        <Box sx={{ mt: 2 }}>
          <BackButton />
        </Box>
      </Box>
    </ModernPageContainer>
  );
}
